import React, { ReactNode, useContext, useMemo, forwardRef } from 'react';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import TableContext from '../_TableContext';
import { StyledTable } from './Table.styles';

export interface TableProps extends SCP<'table'> {
  /** Content of the table. */
  children?: ReactNode;
  /** Value of empty cells. */
  emptyValue?: string;
  /** Actives the debug mode that adds outlines to cells. */
  debug?: boolean;
  /** Display mode, between flex and grid. */
  displayMode?: 'flex' | 'table';
  /** Allow to scroll horizontally if needed. */
  horizontalScroll?: boolean;
  /** @ignore */
  scope?: string[];
}

const TableDefaultProps = {
  emptyValue: '-',
  debug: false,
};

const Table = forwardRef<HTMLDivElement, TableProps>(({ children, emptyValue, debug, scope, ...props }, ref) => {
  const tableContext = useContext(TableContext);

  const newTableContext = useMemo(() => ({
    ...tableContext,
    emptyValue,
    debug,
  }), [tableContext, emptyValue, debug]);

  return (
    <StyledTable
      role="table"
      ref={ref}
      {...props}
    >
      <TableContext.Provider value={newTableContext}>
        {children}
      </TableContext.Provider>
    </StyledTable>
  );
});

Table.defaultProps = TableDefaultProps;

export default Table;
